export enum UnitOfMeasure {
  Gram = 'g',
  MilliGram = 'mg',
  MilliLitre = 'ml',
  NA = 'N/A'
}
